import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  objDescriptionclass: (props) =>
    !props.mediaquery
      ? {
          marginTop: "1.5rem",
          marginBottom: "1.5rem",
          marginLeft: "auto",
          marginRight: "auto",
          width: "100%",
        }
      : { width: "55ch", marginTop: "32px" },
  objTagclass: (props) =>
    !props.mediaquery
      ? {
          display: "inline-block",

          minWidth: "100%",
        }
      : { minWidth: "450px", margin: "16px 0px 8px -8px", padding: 0 },
});

export default useStyles;
